import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// 1. Ant Design
import { Button, Result } from "antd";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
// 5. Types, utils, styles
import { hasPermission } from "@/utils/permissions";
import styles from "@/styles/ProtectedRoute.module.less";
const ProtectedRoute = observer(({ permission, children }) => {
    const { authStore } = getRootStore();
    const navigate = useNavigate();
    return hasPermission(authStore.userRole, permission) ? (_jsx(_Fragment, { children: children })) : (_jsx("div", { className: styles.container, children: _jsx(Result, { status: "403", title: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0430\u0432", subTitle: "\u0423 \u0432\u0430\u0448\u0435\u0439 \u0440\u043E\u043B\u0438 \u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u044D\u0442\u043E\u043C\u0443 \u0440\u0430\u0437\u0434\u0435\u043B\u0443.", extra: _jsx(Button, { type: "primary", onClick: () => navigate("/"), children: "\u041D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E" }) }) }));
});
ProtectedRoute.displayName = "ProtectedRoute";
export default ProtectedRoute;
